<template>
  <div>
    <v-row class="custom-margin-login-register">
      <v-col cols="12" class="text-center">
        <img width="90" src="@/assets/some-point.png" alt="shape" class="register-shape">
        <v-card>
          <v-card-title>
            ثبت نام
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                در درک حساب کاربری ندارید ؟
                <v-icon color="#1ab69d">mdi-emoticon-wink</v-icon>
                <br>
                ثبت نام کنید.
              </v-col>
              <v-col cols="12">
                <v-text-field color="black" label="نام و نام خانوادگی" v-model="student.name"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field color="black" label="شماره همراه" v-model="student.mobile"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field color="black" label="ایمیل" v-model="student.email"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field type="password" color="black" label="رمز عبور" v-model="student.password"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field type="password" color="black" label="تکرار رمز عبور"
                              v-model="student.password_confirmation"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select color="black" :items="states" item-text="label" item-value="id" label="استان محل سکونت"
                          :menu-props="{nudgeBottom: 1000}"
                          @change="getCities()" v-model="student.state_id"></v-select>
              </v-col>
              <v-col cols="12">
                <v-select v-if="cities.length" color="black" :items="cities" item-text="label" item-value="id"
                          label="شهر محل سکونت"
                          :menu-props="{nudgeBottom: 1000}"
                          v-model="student.city_id"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select color="black" :items="schools" item-text="label" item-value="id" label="آموزشگاه"
                          persistent-hint
                          hint="چنانچه از آموزشگاه ثبت نام نمی کنید این فیلد را خالی بگذارید."
                          :menu-props="{nudgeBottom: 1000}"
                          v-model="student.school_id"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <vue-persian-datetime-picker color="black" v-model="student.birth_date"
                                             type="date"
                                             custom-input="#birth_date"
                                             auto-submit></vue-persian-datetime-picker>
                <v-text-field label="تاریخ تولد" v-model="student.birth_date" id="birth_date"
                              color="black">
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select color="black" v-model="student.gender"
                          label="جنسیت"
                          :menu-props="{nudgeBottom: 1000}"
                          :items="[{text:'خانم',value:'female'},{text:'آقا',value:'male'}]"
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field label="عکس پروفایل"
                              @click="profileImageDialog = true" prepend-icon="mdi-plus"
                              color="black"
                              v-model="student.profile_image"></v-text-field>
              </v-col>
              <v-col cols="12" class="text-center">
                <v-btn color="#1ab69d" @click="register()" width="10vw" class="button-normal-white">ثبت نام</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="profileImageDialog" max-width="90vw">
      <drag-and-drop-mobile module="course" ref="image-uploader" @closeUploadFileDialog="profileImageDialog = false"
                            @changeFile="student.profile_image = $event"></drag-and-drop-mobile>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDropMobile from "@/components/Components/Mobile/UploadFile/DragAndDropMobile";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "LoginRegisterMobile",
  components: {DragAndDropMobile, VuePersianDatetimePicker},
  data() {
    return {
      otpStep: 1,
      profileImageDialog: false,
      loginType: 'email',
      waitForOtp: true,
      student: {
        name: null,
        email: null,
        birth_date: null,
        gender: null,
        mobile: null,
        password: null,
        password_confirmation: null,
        profile_image: null,
        state_id: null,
        city_id: null,
        school_id: null,
      },
      credentials: {
        email: null,
        phone: null,
        password: null,
        code: null
      },
      states: [],
      cities: [],
      schools: []
    }
  },
  mounted() {
    this.getStates()
    this.getSchools()
  },
  methods: {
    getSchools() {
      window.axios.get('/school/index').then((res) => {
        this.schools = res.data.data
      })
    },
    loginWithMobile() {
      window.axios.post('/student/auth/otp/verify', {
        mobile: this.credentials.phone,
        code: this.credentials.code
      }).then((res) => {
        this.$store.state.user = res.data.data.user
        this.$store.state.auth = true
        this.$cookies.set('token', 'Bearer ' + res.data.data.token)
        this.$router.go(0)
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 404) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    getStates() {
      window.axios.get('/system/state/index').then((res) => {
        this.states = res.data.data
      })
    },
    getCities() {
      window.axios.get('/system/city/index?state_id=' + this.student.state_id).then((res) => {
        this.cities = res.data.data
      })
    },
    sendOtp() {
      window.axios.post('/student/auth/otp/get', {
        mobile: this.credentials.phone
      }).then(() => {
        this.otpStep = 2
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    register() {
      window.axios.post('/student/register', this.student).then(() => {
        this.openSnackbar('ثبت نام شما با موفقیت انجام شد.', '#1ab69d')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    loginWithEmail() {
      window.axios.post('student/auth/email/login', {
        email: this.credentials.email,
        password: this.credentials.password
      }).then((res) => {
        this.$store.state.user = res.data.data.user
        this.$store.state.auth = true
        this.$cookies.set('token', 'Bearer ' + res.data.data.token)
        this.$router.go(0)
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400 || err.response.status === 404) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
  }
}
</script>

<style scoped>
.login-shape {
  top: 10.8vh;
  right: 10.2vw;
  position: absolute !important;
  z-index: 2;
}

.register-shape {
  top: 65.8vh;
  right: 10.2vw;
  left: 45%;
  z-index: 2;
  position: absolute !important;
}

.custom-margin-login-register {
  margin-top: 10vh;
  margin-left: 10vw !important;
  margin-right: 10vw !important;
  margin-bottom: 20vh!important;
}
</style>